import React from "react"
import styled from "styled-components"

const PreConfigureParticipantsMainbox = styled.div`
    width: 90%;
    max-width: 1600px;
    min-height: 100px;
    background-color: red;
`
export const PreConfigureParticipants = () =>{
    return(
        <PreConfigureParticipantsMainbox>
            </PreConfigureParticipantsMainbox>
    )
}